import styled from 'styled-components';

export const IconLabel = styled.div`
  text-align: center;
  font-size: 0.7em;
  color: ${({ theme }): string => theme.customPalette.panels.header.font};
  pointer-events: none;
  white-space: nowrap;
`;
